module.exports = __webpack_public_path__ + "img/Post Pandemic Views on Health Benefits Infographic.f4877006.png";